import { InitialDataStateModel } from '../../../model';

export class SetInitialData {
  static readonly type = '[Initial Data] Set Initial Data';
  constructor(public payload: InitialDataStateModel) {}
}
